document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  // Animation for the top row (left to right)
  gsap.from(".kg-top-row .kg-image-item", {
    opacity: 0,
    x: -100,
    duration: 1,
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".kg-top-row",
      start: "top 80%",
      end: "top 50%",
      toggleActions: "play none none reverse"
    }
  });

  // Animation for the bottom row (right to left)
  gsap.from(".kg-bottom-row .kg-image-item", {
    opacity: 0,
    x: 100,
    duration: 1,
    stagger: 0.3,
    scrollTrigger: {
      trigger: ".kg-bottom-row",
      start: "top 80%",
      end: "top 50%",
      toggleActions: "play none none reverse"
    }
  });
});
